import { useCreatePortfolioMutation } from 'hooks/mutations/Rewards/useCreatePortfolioMutation'
import { useRewardsTracking } from 'pages/Rewards/hooks/useRewardsTracking'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useCreatePortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()
  const { mutate: createPortfolio, isPending: isCreatingPortfolioPending } =
    useCreatePortfolioMutation()

  const handleCreatePortfolio = (currency: string) => {
    return createPortfolio(
      { currency },
      {
        onSuccess: () => {
          trackSuccess('createPortfolio', { currency })
          onSuccess?.()
        },
        onError: (error: BaseErrorResponse) => {
          trackError('createPortfolio', error, { currency })
          onError?.(error)
        },
      }
    )
  }

  return {
    createPortfolio: handleCreatePortfolio,
    isCreatingPortfolioPending,
  }
}
